import React from 'react';
import GrantSingleMemberForm from '../Forms/GrantSingleMemberForm';

// Single coupon issuing. Used twice, by two routes differing only in which
// promotion type they offer and what they call themselves:
//   Single Member   — promotionType 2 (Member offer)
//   Single Consumer — promotionType 1 (Public promotion)
// A thin pass-through; the form does the work.
function GrantSingleMember(props) {
    return <GrantSingleMemberForm {...props} />;
}

export default GrantSingleMember;
